import { Box } from '@material-ui/core';
import { getLendersByMerchantId } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { Lenders } from '@/components/modules/MerchantDetail/MerchantInLenderContext/components/Lenders';
import { ModuleCorePermissionProps } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MerchantInLenderContext = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: lenders, loading } = useCache(getLendersByMerchantId, { merchantId }, { fallbackData: [] });

  useSetPageLoadingWhenRequesting('MERCHANT_IN_LENDER_STRUCTURE', [loading]);
  if (!merchantId) return null;

  return (
    <Box>
      <Lenders lenders={lenders} merchantId={merchantId} editModeAllowed={canEdit} />
    </Box>
  );
};

export const MerchantInLenderContextModule = withPermissionsModule(MerchantInLenderContext);
